import { COMMERCIAL } from "./i18n_commercial";

export const content = {
  it: {
    nav: [
      { id: "servizi", label: "Servizi" },
      { id: "caso-0", label: "Caso 0" },
      { id: "offerte", label: "Offerte" },
      { id: "metodo", label: "Metodo" },
      { id: "team", label: "Team" },
      { id: "contatti", label: "Contatti" },
    ],
    navCta: "Parliamo",
    cursor: { sector: "Scopri", team: "Incontra" },
    hero: {
      eyebrow: "New Space · New Aviation · AI",
      lines: [
        { text: "Software e intelligenza" },
        { text: "artificiale per chi" },
        { text: "costruisce ", accent: "il cielo." },
      ],
      sub: "Progettiamo software, strumenti dati e soluzioni AI per startup e imprese del New Space e della New Aviation. Partiamo da un processo concreto, ne valutiamo la fattibilità e definiamo il percorso di sviluppo.",
      cta1: "Scopri la diagnosi da 500 €",
      cta2: "Esplora il Caso 0",
      scroll: "Scorri",
      coords: "45.61° N · 8.85° E — Busto Arsizio",
      slides: [{ k: "01", label: "New Space", cap: "Ascesa" }, { k: "02", label: "New Aviation", cap: "In volo" }, { k: "03", label: "Ingegneria", cap: "Il motore" }],
    },
    marquee: ["New Space", "New Aviation", "Intelligenza artificiale spiegabile", "Software su misura", "Data intelligence", "Cloud sicuro", "AI Act ready"],
    stats: {
      items: [
        { v: 15, suffix: "+", label: "Anni di esperienza professionale della fondatrice nello sviluppo commerciale internazionale" },
        { v: 2, suffix: "", label: "Settori verticali, nessun compromesso" },
        { v: 4, suffix: "", label: "Dimensioni di valutazione previste dalla piattaforma in sviluppo" },
        { v: 100, suffix: "%", label: "Soluzioni progettate su misura" },
      ],
    },
    showreel: {
      eyebrow: "Showreel",
      title: "Dove il software incontra il cielo.",
      hint: "Scorri",
      note: "Immagini d'archivio a illustrazione dei settori, non progetti realizzati da ByteVision.",
      captions: ["Osservazione della Terra", "Costellazioni in orbita", "Infrastrutture a terra", "Volo ad alta quota", "Nuove geometrie", "Dati che decidono"],
    },
    sectors: {
      eyebrow: "01 — Settori",
      title: "Due frontiere. Una sola ossessione per la precisione.",
      items: [
        { name: "New Space", tag: "Orbita", bullets: ["Piattaforme dati per startup, incubatori e investitori", "Analisi di dati tecnici, brevettuali e di mercato", "Automazione di documentazione tecnica e progettuale"] },
        { name: "New Aviation", tag: "Atmosfera", bullets: ["Software su misura per operazioni e processi", "Modelli di AI per analisi e previsione", "Architetture cloud sicure e conformi"] },
      ],
    },
    services: {
      eyebrow: "02 — Cosa facciamo",
      labels: { problem: "Problema affrontato", deliverable: "Consegna prevista", next: "Prossimo passo" },
      intro: "Portiamo nel settore aerospaziale competenze di sviluppo software e intelligenza artificiale, con la conoscenza del contesto tecnico, normativo e finanziario in cui operano le imprese del settore.",
      items: [
        { title: "Sviluppo software su misura", desc: "Piattaforme web, applicazioni e gestionali progettati sui processi reali dell'impresa, dalla prima versione alla scala.", problem: "Processi gestiti con fogli di calcolo, email e strumenti non integrati.", deliverable: "Applicazione o piattaforma in produzione, con documentazione e piano di evoluzione.", next: "Consulenza strategica, poi preventivo di sviluppo." },
        { title: "Soluzioni di intelligenza artificiale", desc: "Modelli predittivi, classificazione e analisi di dati complessi, integrati nei flussi di lavoro esistenti.", problem: "Decisioni che dipendono da dati complessi letti a mano o troppo tardi.", deliverable: "Modello o assistente integrato nel flusso di lavoro, con criteri di verifica umana.", next: "Diagnosi di fattibilità da 500 €." },
        { title: "Data engineering e analytics", desc: "Raccolta e integrazione di dati tecnici, brevettuali e di mercato, con dashboard e KPI leggibili da chi decide.", problem: "Dati dispersi tra fonti diverse, difficili da confrontare e aggiornare.", deliverable: "Pipeline dati e dashboard con KPI concordati.", next: "Diagnosi di fattibilità o consulenza strategica." },
        { title: "Automazione dei processi", desc: "Meno lavoro manuale su documenti, report e pratiche ripetitive.", problem: "Ore ripetitive su documenti, report e pratiche, come nel Caso 0.", deliverable: "Flusso automatizzato con revisione umana nei passaggi critici.", next: "Diagnosi di fattibilità da 500 €." },
        { title: "Infrastruttura cloud", desc: "Architetture scalabili su AWS e Azure, DevOps e continuità operativa.", problem: "Infrastruttura fragile o costosa da far crescere.", deliverable: "Architettura cloud documentata, con pratiche DevOps e continuità operativa.", next: "Consulenza strategica, poi preventivo." },
        { title: "Cybersecurity e conformità", desc: "Protezione dei dati e sistemi di AI progettati fin dall'inizio tenendo conto dei requisiti del GDPR e dell'AI Act europeo.", problem: "Dati sensibili e sistemi AI senza una valutazione dei requisiti normativi.", deliverable: "Analisi dei rischi e misure tecniche e organizzative da implementare.", next: "Consulenza strategica." },
      ],
    },
    audience: {
      eyebrow: "03 — Con chi lavoriamo",
      title: "Per chi guarda in alto.",
      items: [
        { title: "Startup New Space e New Aviation", desc: "Software e strumenti dati per crescere più in fretta e presentarsi meglio a clienti e investitori." },
        { title: "Imprese della filiera aerospaziale", desc: "Digitalizzazione e AI per PMI e fornitori che vogliono modernizzare processi e prodotti." },
        { title: "Incubatori e distretti", desc: "Piattaforme per seguire, misurare e valorizzare le startup del proprio ecosistema." },
        { title: "Investitori", desc: "Strumenti di analisi per leggere tecnologie complesse e decidere sulla base dei dati." },
      ],
    },
    method: {
      eyebrow: "04 — Come lavoriamo",
      title: "Quattro fasi. Nessuna zona d'ombra.",
      hint: "Scorri per seguire la traiettoria",
      steps: [
        { title: "Analisi", desc: "Capiamo processi, dati disponibili e obiettivi di business." },
        { title: "Progettazione", desc: "Definiamo architettura, modelli e priorità, con tempi e costi chiari." },
        { title: "Sviluppo", desc: "Rilasci progressivi, testati con chi userà la soluzione." },
        { title: "Evoluzione", desc: "Supporto, formazione e miglioramento continuo dopo il lancio." },
      ],
    },
    why: {
      eyebrow: "05 — Perché ByteVision",
      title: "Specialisti, non generalisti.",
      items: [
        { title: "Verticali", desc: "Lavoriamo solo in New Space e New Aviation: conosciamo il linguaggio, i dati e gli interlocutori del settore." },
        { title: "AI spiegabile", desc: "I nostri modelli mostrano da cosa nascono i loro risultati." },
        { title: "Su misura", desc: "Soluzioni modulari, costruite sull'impresa e non su un pacchetto standard." },
      ],
    },
    platform: {
      eyebrow: "In sviluppo",
      title: "Intelligence AI per gli investimenti nel New Space",
      text: "Oltre ai servizi, ByteVision sta sviluppando una piattaforma proprietaria basata sull'intelligenza artificiale che rende leggibili le startup della Space Economy. Aiuterà gli investitori a valutare tecnologie complesse con criteri oggettivi, e le startup a capire cosa le separa dal prossimo round.",
      bullets: [
        { k: "Valutazione su più dimensioni", v: "maturità tecnologica, mercato, team e solidità finanziaria in un'unica lettura." },
        { k: "Dati verticali", v: "fonti tecniche, brevettuali e di investimento specifiche del settore aerospaziale." },
        { k: "AI spiegabile", v: "progettata fin dall'inizio per i requisiti dell'AI Act europeo." },
      ],
      ask: "Sei un investitore? Richiedi la presentazione riservata del progetto.",
      cta: "Richiedi la presentazione",
      preview: "Anteprima concettuale",
      axes: ["Tecnologia", "Mercato", "Team", "Finanza"],
      score: "Indice composito",
      demoCta: "Prova la demo",
    },
    demo: {
      title: "Demo: valuta una startup space",
      sub: "Descrivi in poche righe una startup del New Space o New Aviation: tecnologia, team, traction, capitale. L'AI restituisce una valutazione spiegabile su quattro dimensioni.",
      placeholder: "Es. Startup che sviluppa propulsori elettrici per nanosatelliti; team di 6 ingegneri ex Thales Alenia; brevetto depositato; TRL 5; pre-seed di 400k; primo cliente pilota in trattativa…",
      submit: "Genera valutazione", loading: "Analisi in corso…", err: "Valutazione non riuscita. Riprova.",
      readiness: "Stadio", strengths: "Punti di forza", risks: "Rischi", again: "Nuova valutazione",
      note: "Demo pubblica a scopo illustrativo. La piattaforma completa utilizza fonti tecniche, brevettuali e finanziarie verticali.",
      min: "Inserisci almeno 20 caratteri.",
    },
    offers: {
      eyebrow: "Su selezione",
      title: "Pochi progetti. Seguiti fino in fondo.",
      sub: "Accettiamo un numero limitato di consulenze ogni mese, per dedicare a ciascun progetto l'attenzione che merita. La selezione avviene su candidatura.",
      buy: "Procedi al pagamento", redirecting: "Reindirizzamento…", err: "Impossibile avviare il pagamento. Riprova.",
      emailLabel: "La tua email (per la conferma)",
      apply: "Candidati alla selezione", invited: "Hai già ricevuto l'invito?", waitlist: "Richiedi la presentazione riservata",
      items: {
        bv_strategy_call: {
          name: "Consulenza strategica", duration: "Su invito · 6 progetti al mese",
          desc: "Una sessione di lavoro riservata con i fondatori di ByteVision per mettere a fuoco il tuo progetto software o AI: obiettivi, dati, architettura e una roadmap con tempi e costi. Riceverai una risposta alla candidatura entro 48 ore.",
          bullets: ["Sessione di 90 minuti con i fondatori", "Analisi preliminare del caso d'uso e dei dati", "Memorandum strategico entro 5 giorni"],
          badge: "Selezione",
        },
        bv_platform_early_access: {
          name: "Early Access piattaforma", duration: "Prossimamente · lista d'attesa",
          desc: "L'accesso anticipato alla piattaforma di intelligence AI per investimenti nel New Space sarà riservato a un circolo ristretto di investitori e family office. Le iscrizioni apriranno su invito.",
          bullets: ["Onboarding dedicato e sessione riservata", "Influenza diretta sulla roadmap", "Accesso prioritario alla beta"],
          badge: "Prossimamente",
        },
      },
      status: {
        checking: "Verifica del pagamento in corso…",
        successTitle: "Pagamento confermato", successText: "Grazie. Ti abbiamo inviato la conferma via email e ti contatteremo entro un giorno lavorativo per organizzare i prossimi passi.",
        pendingTitle: "Pagamento in elaborazione", pendingText: "La conferma sta impiegando più del previsto. Riceverai comunque un'email appena il pagamento sarà registrato.",
        cancelTitle: "Pagamento annullato", cancelText: "Nessun addebito effettuato. Se hai domande, scrivici o usa la chat.",
        close: "Chiudi",
      },
    },
    chat: {
      title: "Assistente ByteVision", status: "Assistente automatico (AI) · nessun operatore umano",
      welcome: "Benvenuto. Sono l'assistente automatico di ByteVision (risposte generate da AI): posso raccontarti i nostri servizi, i settori che seguiamo, il team e la piattaforma per investitori. Come posso aiutarti?",
      placeholder: "Scrivi un messaggio…", send: "Invia", open: "Apri la chat", close: "Chiudi la chat",
      err: "Si è verificato un problema. Riprova tra poco.",
      suggestions: ["Cosa include la diagnosi da 500 €?", "Che cos'è il Caso 0?", "Come funziona la consulenza strategica?"],
    },
    team: {
      eyebrow: "06 — Team",
      title: "Le persone dietro la traiettoria.",
      members: [
        { name: "Esthefany Guillermo", initials: "EG", role: "Fondatrice e CEO", bio: "PhD in Business Administration. Oltre quindici anni di sviluppo commerciale tra Italia, Francia e mercati internazionali, con focus su New Space e posizionamento premium." },
        { name: "Philippe Boissat", initials: "PB", role: "Esperto spaziale", bio: "Ex Deloitte. Ingegneria spaziale e telecomunicazioni nel settore aerospaziale." },
        { name: "David Dolama", initials: "DD", role: "Architettura software e cybersecurity", bio: "Fondatore di HelpySoft, attivo anche in Airbus. Architetture software, infrastruttura cloud e sicurezza dei dati." },
      ],
    },
    partners: { eyebrow: "Partner" },
    contact: {
      eyebrow: "07 — Contatti",
      title: ["Hai un progetto", "in orbita?"],
      sub: "Raccontaci cosa stai costruendo: ti rispondiamo con una prima proposta.",
      email: "Email", hq: "Sede", pec: "PEC",
      address: "Viale Cadorna 2, 21052 Busto Arsizio (VA), Italia",
    },
    form: {
      name: "Nome e cognome", email: "Email", company: "Azienda / Ente", fund: "Fondo / Società", sector: "Settore",
      sectors: ["New Space", "New Aviation", "Altro"], message: "Raccontaci il tuo progetto", messageInv: "Messaggio (facoltativo)",
      submit: "Invia richiesta", sending: "Invio in corso…", ok: "Grazie! Ti risponderemo a breve.", err: "Invio non riuscito. Riprova.",
      projectTitle: "Parliamo del tuo progetto", projectSub: "Compila il modulo: ti rispondiamo con una prima proposta.",
      consultingTitle: "Candidatura alla consulenza strategica", consultingSub: "Raccontaci il progetto e la fase in cui ti trovi. Selezioniamo sei progetti al mese e rispondiamo entro 48 ore.",
      investorTitle: "Presentazione riservata", investorSub: "Richiedi la presentazione riservata della piattaforma di intelligence AI per il New Space.",
      consent: "Inviando accetti il trattamento dei dati secondo la privacy policy.",
    },
    footer: {
      legal: "BYTE VISION S.R.L.S. · Sede legale: Viale Cadorna 2, 21052 Busto Arsizio (VA) · P.IVA e C.F. 04112140126 · REA VA-[da visura] · Capitale sociale € [da visura] i.v. · PEC esthefanyguillermo@pec-amministratore.it",
      privacy: "Privacy policy", cookie: "Cookie policy", top: "Torna su",
      privacyText: "I dati inviati tramite i moduli del sito sono trattati da BYTE VISION S.R.L.S. esclusivamente per rispondere alle richieste, nel rispetto del Regolamento UE 2016/679 (GDPR). Per esercitare i tuoi diritti scrivi a bytevisionsrls@pec.it.",
      cookieText: "Questo sito utilizza solo cookie tecnici necessari al funzionamento. Non vengono utilizzati cookie di profilazione.",
    },
  },
  en: {
    nav: [
      { id: "servizi", label: "Services" },
      { id: "caso-0", label: "Case 0" },
      { id: "offerte", label: "Offers" },
      { id: "metodo", label: "Method" },
      { id: "team", label: "Team" },
      { id: "contatti", label: "Contact" },
    ],
    navCta: "Let's talk",
    cursor: { sector: "Discover", team: "Meet" },
    hero: {
      eyebrow: "New Space · New Aviation · AI",
      lines: [
        { text: "Software and artificial" },
        { text: "intelligence for those" },
        { text: "who build ", accent: "the sky." },
      ],
      sub: "We design software, data tools and AI solutions for startups and companies in the New Space and New Aviation. We start from a concrete process, assess its feasibility and define the development path.",
      cta1: "Discover the €500 diagnosis",
      cta2: "Explore Case 0",
      scroll: "Scroll",
      coords: "45.61° N · 8.85° E — Busto Arsizio",
      slides: [{ k: "01", label: "New Space", cap: "Ascent" }, { k: "02", label: "New Aviation", cap: "In flight" }, { k: "03", label: "Engineering", cap: "The engine" }],
    },
    marquee: ["New Space", "New Aviation", "Explainable artificial intelligence", "Tailor-made software", "Data intelligence", "Secure cloud", "AI Act ready"],
    stats: {
      items: [
        { v: 15, suffix: "+", label: "Years of the founder's professional experience in international business development" },
        { v: 2, suffix: "", label: "Vertical sectors, no compromise" },
        { v: 4, suffix: "", label: "Assessment dimensions planned for the platform in development" },
        { v: 100, suffix: "%", label: "Solutions designed to measure" },
      ],
    },
    showreel: {
      eyebrow: "Showreel",
      title: "Where software meets the sky.",
      hint: "Scroll",
      note: "Stock imagery illustrating the sectors, not projects delivered by ByteVision.",
      captions: ["Earth observation", "Constellations in orbit", "Ground infrastructure", "High-altitude flight", "New geometries", "Data that decides"],
    },
    sectors: {
      eyebrow: "01 — Sectors",
      title: "Two frontiers. One obsession with precision.",
      items: [
        { name: "New Space", tag: "Orbit", bullets: ["Data platforms for startups, incubators and investors", "Analysis of technical, patent and market data", "Automation of technical and design documentation"] },
        { name: "New Aviation", tag: "Atmosphere", bullets: ["Custom software for operations and processes", "AI models for analysis and forecasting", "Secure and compliant cloud architectures"] },
      ],
    },
    services: {
      eyebrow: "02 — What we do",
      labels: { problem: "Problem addressed", deliverable: "Expected deliverable", next: "Next step" },
      intro: "We bring software development and artificial intelligence expertise to the aerospace sector, together with an understanding of the technical, regulatory and financial context in which its companies operate.",
      items: [
        { title: "Custom software development", desc: "Web platforms, applications and management systems designed around the company's real processes, from first version to scale.", problem: "Processes run on spreadsheets, email and non-integrated tools.", deliverable: "Application or platform in production, with documentation and an evolution plan.", next: "Strategic consulting, then a development quotation." },
        { title: "Artificial intelligence solutions", desc: "Predictive models, classification and analysis of complex data, integrated into existing workflows.", problem: "Decisions that depend on complex data read by hand or too late.", deliverable: "Model or assistant integrated into the workflow, with human verification criteria.", next: "€500 feasibility diagnosis." },
        { title: "Data engineering & analytics", desc: "Collection and integration of technical, patent and market data, with dashboards and KPIs readable by decision makers.", problem: "Data scattered across sources, hard to compare and update.", deliverable: "Data pipeline and dashboards with agreed KPIs.", next: "Feasibility diagnosis or strategic consulting." },
        { title: "Process automation", desc: "Less manual work on documents, reports and repetitive tasks.", problem: "Repetitive hours on documents, reports and paperwork, as in Case 0.", deliverable: "Automated flow with human review at critical steps.", next: "€500 feasibility diagnosis." },
        { title: "Cloud infrastructure", desc: "Scalable architectures on AWS and Azure, DevOps and business continuity.", problem: "Fragile infrastructure or costly to scale.", deliverable: "Documented cloud architecture with DevOps practices and business continuity.", next: "Strategic consulting, then quotation." },
        { title: "Cybersecurity & compliance", desc: "Data protection and AI systems designed from day one with GDPR and European AI Act requirements in mind.", problem: "Sensitive data and AI systems without an assessment of regulatory requirements.", deliverable: "Risk analysis and technical and organisational measures to implement.", next: "Strategic consulting." },
      ],
    },
    audience: {
      eyebrow: "03 — Who we work with",
      title: "For those who look up.",
      items: [
        { title: "New Space & New Aviation startups", desc: "Software and data tools to grow faster and present themselves better to clients and investors." },
        { title: "Aerospace supply-chain companies", desc: "Digitalisation and AI for SMEs and suppliers who want to modernise processes and products." },
        { title: "Incubators & clusters", desc: "Platforms to follow, measure and showcase the startups of their ecosystem." },
        { title: "Investors", desc: "Analysis tools to read complex technologies and make data-driven decisions." },
      ],
    },
    method: {
      eyebrow: "04 — How we work",
      title: "Four phases. No grey areas.",
      hint: "Scroll to follow the trajectory",
      steps: [
        { title: "Analysis", desc: "We understand processes, available data and business goals." },
        { title: "Design", desc: "We define architecture, models and priorities, with clear timelines and costs." },
        { title: "Development", desc: "Progressive releases, tested with the people who will use the solution." },
        { title: "Evolution", desc: "Support, training and continuous improvement after launch." },
      ],
    },
    why: {
      eyebrow: "05 — Why ByteVision",
      title: "Specialists, not generalists.",
      items: [
        { title: "Vertical", desc: "We work only in New Space and New Aviation: we know the language, the data and the stakeholders of the sector." },
        { title: "Explainable AI", desc: "Our models show where their results come from." },
        { title: "Tailor-made", desc: "Modular solutions, built around the company rather than a standard package." },
      ],
    },
    platform: {
      eyebrow: "In development",
      title: "AI intelligence for New Space investment",
      text: "Beyond our services, ByteVision is developing a proprietary AI-based platform that makes Space Economy startups readable. It will help investors assess complex technologies with objective criteria, and startups understand what separates them from their next round.",
      bullets: [
        { k: "Multi-dimensional assessment", v: "technology maturity, market, team and financial strength in a single reading." },
        { k: "Vertical data", v: "technical, patent and investment sources specific to the aerospace sector." },
        { k: "Explainable AI", v: "designed from day one for the requirements of the European AI Act." },
      ],
      ask: "Are you an investor? Request the confidential project presentation.",
      cta: "Request the presentation",
      preview: "Concept preview",
      axes: ["Technology", "Market", "Team", "Finance"],
      score: "Composite index",
      demoCta: "Try the demo",
    },
    demo: {
      title: "Demo: evaluate a space startup",
      sub: "Describe a New Space or New Aviation startup in a few lines: technology, team, traction, capital. The AI returns an explainable assessment across four dimensions.",
      placeholder: "E.g. Startup developing electric propulsion for nanosatellites; team of 6 ex-Thales Alenia engineers; patent filed; TRL 5; 400k pre-seed raised; first pilot customer in negotiation…",
      submit: "Generate assessment", loading: "Analysing…", err: "Evaluation failed. Please try again.",
      readiness: "Stage", strengths: "Strengths", risks: "Risks", again: "New assessment",
      note: "Public demo for illustration only. The full platform uses vertical technical, patent and financial sources.",
      min: "Please enter at least 20 characters.",
    },
    offers: {
      eyebrow: "By selection",
      title: "Few projects. Followed all the way.",
      sub: "We accept a limited number of consultancies each month, to give every project the attention it deserves. Selection is by application.",
      buy: "Proceed to payment", redirecting: "Redirecting…", err: "Could not start the payment. Please try again.",
      emailLabel: "Your email (for the confirmation)",
      apply: "Apply for selection", invited: "Already received your invitation?", waitlist: "Request the confidential presentation",
      items: {
        bv_strategy_call: {
          name: "Strategic consulting", duration: "By invitation · 6 projects a month",
          desc: "A private working session with ByteVision's founders to sharpen your software or AI project: goals, data, architecture and a roadmap with timing and costs. You will hear back on your application within 48 hours.",
          bullets: ["90-minute session with the founders", "Preliminary use-case and data analysis", "Strategic memorandum within 5 days"],
          badge: "Selection",
        },
        bv_platform_early_access: {
          name: "Platform Early Access", duration: "Coming soon · waiting list",
          desc: "Early access to the AI intelligence platform for New Space investment will be reserved for a small circle of investors and family offices. Registrations will open by invitation.",
          bullets: ["Dedicated onboarding and private session", "Direct influence on the roadmap", "Priority access to the beta"],
          badge: "Coming soon",
        },
      },
      status: {
        checking: "Verifying your payment…",
        successTitle: "Payment confirmed", successText: "Thank you. We have emailed your confirmation and will contact you within one business day to arrange the next steps.",
        pendingTitle: "Payment processing", pendingText: "Confirmation is taking longer than expected. You will still receive an email as soon as the payment is recorded.",
        cancelTitle: "Payment cancelled", cancelText: "No charge was made. If you have questions, write to us or use the chat.",
        close: "Close",
      },
    },
    chat: {
      title: "ByteVision Assistant", status: "Automated AI assistant · no human operator",
      welcome: "Welcome. I am ByteVision's automated assistant (AI-generated replies): I can walk you through our services, the sectors we serve, the team and the investor platform. How may I help?",
      placeholder: "Write a message…", send: "Send", open: "Open chat", close: "Close chat",
      err: "Something went wrong. Please try again shortly.",
      suggestions: ["What does the €500 diagnosis include?", "What is Case 0?", "How does strategic consulting work?"],
    },
    team: {
      eyebrow: "06 — Team",
      title: "The people behind the trajectory.",
      members: [
        { name: "Esthefany Guillermo", initials: "EG", role: "Founder & CEO", bio: "PhD in Business Administration. Over fifteen years of business development across Italy, France and international markets, focused on New Space and premium positioning." },
        { name: "Philippe Boissat", initials: "PB", role: "Space expert", bio: "Formerly at Deloitte. Space engineering and telecommunications in the aerospace sector." },
        { name: "David Dolama", initials: "DD", role: "Software architecture & cybersecurity", bio: "Founder of HelpySoft, also working at Airbus. Software architecture, cloud infrastructure and data security." },
      ],
    },
    partners: { eyebrow: "Partners" },
    contact: {
      eyebrow: "07 — Contact",
      title: ["Got a project", "in orbit?"],
      sub: "Tell us what you are building: we will reply with a first proposal.",
      email: "Email", hq: "Office", pec: "PEC",
      address: "Viale Cadorna 2, 21052 Busto Arsizio (VA), Italy",
    },
    form: {
      name: "Full name", email: "Email", company: "Company / Organisation", fund: "Fund / Firm", sector: "Sector",
      sectors: ["New Space", "New Aviation", "Other"], message: "Tell us about your project", messageInv: "Message (optional)",
      submit: "Send request", sending: "Sending…", ok: "Thank you! We will get back to you shortly.", err: "Sending failed. Please try again.",
      projectTitle: "Let's talk about your project", projectSub: "Fill in the form: we will reply with a first proposal.",
      consultingTitle: "Application for strategic consulting", consultingSub: "Tell us about the project and the stage you are at. We select six projects a month and reply within 48 hours.",
      investorTitle: "Confidential presentation", investorSub: "Request the confidential presentation of our AI intelligence platform for New Space.",
      consent: "By sending you accept data processing as per our privacy policy.",
    },
    footer: {
      legal: "BYTE VISION S.R.L.S. · Registered office: Viale Cadorna 2, 21052 Busto Arsizio (VA), Italy · VAT & Tax code 04112140126 · REA VA-[da visura] · Share capital € [da visura] fully paid · PEC esthefanyguillermo@pec-amministratore.it",
      privacy: "Privacy policy", cookie: "Cookie policy", top: "Back to top",
      privacyText: "Data sent through the website forms is processed by BYTE VISION S.R.L.S. solely to answer requests, in accordance with EU Regulation 2016/679 (GDPR). To exercise your rights write to bytevisionsrls@pec.it.",
      cookieText: "This website only uses technical cookies required for it to work. No profiling cookies are used.",
    },
  },
};

for (const l of ["it", "en"]) Object.assign(content[l], COMMERCIAL[l]);

export const CONTACT = {
  email: "bytevisionsrls@pec.it",
  pec: "esthefanyguillermo@pec-amministratore.it",
};

export const PARTNERS = ["3i3 Signature", "HelpySoft", "Visio-Form", "FuturSkills"];

export const SHOWREEL = [
  "https://images.unsplash.com/photo-1446776877081-d282a0f896e2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  "https://images.unsplash.com/photo-1460186136353-977e9d6085a1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  "https://images.unsplash.com/photo-1428908728789-d2de25dbd4e2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  "https://images.unsplash.com/photo-1663011674120-bae80b78377c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  "https://images.unsplash.com/photo-1732200584655-3511db5c24e2?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
];

export const IMAGES = {
  satellite: "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  evtol: "https://images.unsplash.com/photo-1520437358207-323b43b50729?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  earth: "https://images.unsplash.com/photo-1634176866089-b633f4aec882?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
